import React, {
    useEffect,
    useMemo,
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _get from 'lodash/get';

import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints.ts';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import {
    FILTER_ANIMATION_SECONDS,
    FILTER_BREAKPOINT,
} from 'bdvp-advanced-search';
import {
    useDictionary,
    useMediaConfig,
} from 'bdvp-common/src/hooks/config';
import {
    useDidUpdate,
    useMedia,
} from 'bdvp-common/src/hooks';
import { MEDIA_CONFIG_CONTEXT } from 'bdvp-common/src/utils/constants';
import Head from 'bdvp-common/src/components/Head';
// See TODO below...
// import NotFound from 'bdvp-common/src/components/NotFound';
// import Error from 'bdvp-common/src/components/Error';
import NotificationContainer from 'bdvp-common/src/containers/Notification';
import NotificationRenderer from 'bdvp-common/src/components/NotificationRenderer';
import { Tracking } from 'bdvp-tracking';

import Row from '../../containers/Row';
import LazyLoad from '../LazyLoad';
import SkeletonRow from '../Row/SkeletonRow';

const Notification = styled(NotificationContainer)`
    margin: 20px 14px 0px 14px;

    ${media.mdmin`
        margin: 25px 16px 0px 16px;
    `}

    ${media.lgmin`
        margin: 25px 32px 0px 32px;
    `}
`;

const Wrapper = styled.div`
    padding: 25px 0 30px;
`;

const SKELETON_ROWS = new Array(5).fill(null);

const Homepage = ({
    data,
    isLoading,
    error,
    isFilterModalOpen,
}) => {

    const isFilterInModal = useMedia(
        [`(min-width: ${BREAKPOINTS[FILTER_BREAKPOINT]})`],
        [false],
        true
    );
    const config = useMediaConfig(MEDIA_CONFIG_CONTEXT.home);
    const dictionary = useDictionary();
    const rows = useMemo(() => _get(data, 'homepageModules.modules[0].modules[0].modules', []), [data]);

    useEffect(() => {

        window.scrollTo(0, 0);
        Tracking.trackHomePageView();

    }, []);

    useDidUpdate(() => {

        if(!isFilterInModal) {

            setTimeout(() => {

                window.dispatchEvent(new Event('resize'));

            }, FILTER_ANIMATION_SECONDS / 1000);

        }

    }, [isFilterModalOpen]);

    // TODO: what triggers these if anything?
    // if (title === 'Not Found') {

    //     return <NotFound />;

    // }

    // if (error) {

    //     return <Error />;

    // }

    return (
        <>
            <Head
                title={_get(dictionary, 'homepage_title', 'Major League Baseball Video | MLB Film Room')}
                description={_get(dictionary, 'homepage_description', 'Watch game highlights, top plays, home runs, and replays. Create and share your own video.')}
            />
            <NotificationRenderer
                config={config}
                render={(id, contentConfig) => (
                    <Notification id={id} contentConfig={contentConfig} />
                )}
            />
            <Wrapper>
                <Row rank={0} />
                {isLoading
                    ? SKELETON_ROWS.map((e, i) => <SkeletonRow key={i} />)
                    : rows.map((row, index) => (
                        <LazyLoad
                            key={row.instanceId}
                            render={({
                                elementRef,
                                isVisible,
                            }) => {

                                return (
                                    <Row
                                        ref={elementRef}
                                        skip={!isVisible}
                                        ssr={false}
                                        properties={row.properties}
                                        rank={index + 1}
                                    />
                                );

                            }}
                        />
                    ))}
            </Wrapper>
        </>
    );

};

Homepage.propTypes = {
    data: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isFilterModalOpen: PropTypes.bool.isRequired,
    error: PropTypes.object,
};

Homepage.defaultProps = {
    error: undefined,
};

export default Homepage;
